module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"Slider":{"more":"Více"}},"en":{"Slider":{"more":"More"}}}')
  delete Component.options._Ctor
}
